/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 添加或清除热门项目客户端缓存标记
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ClientCacheParams {
  constructor(public action?: string, public productIds?: string) {}
}

export default async function (
  params: ClientCacheParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/cache/client`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
